/*
This file is located in the main branch
Last time the file was updated (UTC): [06.12.2023 15:23:16]
Permissions to update outside the main branch: [false]
*/

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SignInResponse } from 'models/api/users';

export const refresh = async (axios: AxiosInstance, config: AxiosRequestConfig) =>
    await axios.post<SignInResponse>('/token/refresh', null, config);

export const revoke = async (axios: AxiosInstance) => await axios.post('/token/revoke');
